import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return(
            <footer className="footer-section">
                <h2>Connect With Us</h2>
                {/* <!-- CONTACT SECTION --> */}
                    <div className="container">
                    {/* <!-- SOCIAL MEDIA LINKS --> */}
                    <ul className="social-media-links">
                        <li>
                            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i><span className="sr-only">Facebook</span></a>
                        </li>
                        <li>
                            <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i><span className="sr-only">Twitter</span></a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i><span className="sr-only">Instagram</span></a>
                        </li>
                        <li>
                            <a href="mailto:magalj@uw.edu"><i className="fa fa-envelope"></i><span className="sr-only">Email</span></a>
                        </li>
                    </ul>
                    {/* <!-- COPYRIGHT --> */}
                    <div className="copyright">Copyright © GrubRun.com, All rights reserved
                        <br />
                        Data from <a href="https://www.yelp.com/developers/documentation/v3">Yelp</a>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;